import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/stonecode_mail_editor_mail_types/{?id}')
@doc.timestampable
abstract class AbstractStonecodeMailEditorMailTypeModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		partial: string;
	};

	declare private _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Website_StonecodeMailEditorMailTypeReference;
}

interface AbstractStonecodeMailEditorMailTypeModel extends Timestampable {}

export default AbstractStonecodeMailEditorMailTypeModel;
